import AdminCompany from "../components/AdminCompany";

import useAdmin from "../hooks/useAdminCompany";

function AdminCompanyPage(props) {
    const UseAdminProps = useAdmin(props);
    return <AdminCompany {...UseAdminProps} />
}

export default AdminCompanyPage;